import React, { FC } from 'react';
import styles from '../index.module.css';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { Link } from 'react-router-dom';
import { OrderType } from 'models/order.model';
import { formatNumber, getOrderStatus } from 'utils/functions';
import { ENUM_STATUS } from 'utils/enum';

type Props = {
  order: OrderType;
};

const OrderDetailsHeader: FC<Props> = ({ order }) => {
  const { role } = useRoleContext();
  const note = order?.cancelled_note;
  const cutlery = order.order_details.cutlery;
  const isPending = getOrderStatus(order) === ENUM_STATUS.PENDING;
  const isCSAdmin = role === ENUM_ROLE.CS_SUPER_ADMIN || role === ENUM_ROLE.CS_ADMIN;

  const numberOfBrands = order.calculated_order?.brand_ids?.length;
  const numberOfMeals = (order.calculated_order?.meals ?? []).reduce((mealsAcc, meal) => {
    const innerMeals = meal?.meals?.length;
    mealsAcc += innerMeals;
    return mealsAcc;
  }, 0);

  return (
    <div>
      <div
        className={`text-xs flex flex-wrap ${styles['section-header-2']} py-[12px] justify-normal gap-3 items-center`}>
        <div className='border-left flex gap-4 items-center'>
          <div>
            <h6 className='font-medium text-base text-gray-5'>Order details</h6>
            <p className='text-xs text-gray-8'>
              {numberOfBrands} brands, {numberOfMeals} items
            </p>
          </div>
        </div>
        <p className='ml-auto bg-gray-11 text-gray-5 border border-[#EAECEC] rounded-[40px] p-2'>
          Cutlery:{' '}
          <span className={cutlery ? 'text-blue-5' : 'text-red-5'}>{cutlery ? 'Yes' : 'No'}</span>
        </p>
        <p className='bg-gray-11 text-gray-5 border border-[#EAECEC] rounded-[40px] p-2'>
          {formatNumber(order.calculated_order?.total_amount)}
        </p>
        {isPending && isCSAdmin && (
          <Link
            to={`/order/${order.order_code}`}
            className='p-2 border border-[#FDE9AF] bg-[#D5830017] text-[#D58300] rounded-2xl'>
            Update Order
          </Link>
        )}
      </div>
      {note && (
        <div className='font-semibold uppercase text-xs px-6 pt-2'>
          Cancellation Note: <span className='text-red-5'>{note}</span>
        </div>
      )}
    </div>
  );
};

export default OrderDetailsHeader;
